export default __webpack_public_path__ + "static/media/4.blur.03977706.jpeg";